import React, { useRef, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { message } from "antd";
import { uploadFile } from "../service";

const FileUpload = ({ onChange, file }) => {
  const fileRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Check file type
    if (!selectedFile.type.startsWith('image/')) {
      message.error('Please upload an image file');
      return;
    }

    // Check file size (max 5MB)
    if (selectedFile.size > 5 * 1024 * 1024) {
      message.error('File size should be less than 5MB');
      return;
    }

    setLoading(true);
    try {
      const result = await uploadFile(selectedFile);
      if (result && result.url) {
        onChange(result.url);
        message.success('File uploaded successfully');
      } else {
        message.error('File upload failed');
      }
    } catch (error) {
      message.error('Failed to upload file');
      console.error('Upload error:', error);
    } finally {
      setLoading(false);
      // Clear the input value to allow uploading the same file again
      if (fileRef.current) {
        fileRef.current.value = '';
      }
    }
  };

  return (
    <div className="border border-dashed border-gray-500 rounded-md flex justify-between items-center py-2">
      {file === null && (
        <div className="flex-1 bg-form-bg ml-2 text-md text-gray-600">
          Please choose a file
        </div>
      )}
      {file && (
        <div className="flex-1 bg-form-bg ml-2 text-md text-gray-600">
          {file.length > 30 ? `${file.substring(0, 30)}...` : file}
        </div>
      )}
      <input
        type="file"
        hidden
        ref={fileRef}
        accept=".jpg, .png, .jpeg"
        onChange={handleFileChange}
        disabled={loading}
      />
      <button
        className="flex-1 text-md text-gray-600"
        onClick={() => fileRef.current.click()}
        disabled={loading}
      >
        <UploadOutlined /> {loading ? 'Uploading...' : 'Upload'}
      </button>
    </div>
  );
};

export default FileUpload;
